import {
	MESSAGE_HP_INCREASED,
	MESSAGE_LEVEL_UP,
	MESSAGE_MP_INCREASED,
} from 'constants/message';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = {
	message: {
		visible: boolean;
		text: string;
	};
	name: string;
	job: string;
	sex: string;
	serif: string;
	level: number;
	hp: number;
	mp: number;
	exp: number;
};

const INITIAL_STATE: State = {
	message: {
		visible: false,
		text: '',
	},
	name: '',
	job: '',
	sex: '',
	serif: '',
	level: 1,
	hp: 15,
	mp: 4,
	exp: 0,
};

export const appSlice = createSlice({
	name: 'app',
	initialState: INITIAL_STATE,
	reducers: {
		resetMessage: (state) => {
			state.message = INITIAL_STATE.message;
		},
		showMessage: (state, action: PayloadAction<string>) => {
			state.message.text = action.payload;
			state.message.visible = true;
		},
		hideMessage: (state) => {
			state.message.visible = false;
		},
		saveName: (state, action: PayloadAction<string>) => {
			state.name = action.payload;
		},
		saveJob: (state, action: PayloadAction<string>) => {
			state.job = action.payload;
		},
		saveSex: (state, action: PayloadAction<string>) => {
			state.sex = action.payload;
		},
		saveSerif: (state, action: PayloadAction<string>) => {
			state.serif = action.payload;
		},
		expUp: (state) => {
			const nextExp =
				typeof state.exp === 'undefined' ? 1 : state.exp + 1;
			state.exp = nextExp;
			if (nextExp % 5 === 0) {
				const nextLevel = state.level + 1;
				state.level = nextLevel;
				const plusHp = Math.floor(Math.random() * 10) + 1;
				state.hp += plusHp;
				const plusMp = Math.floor(Math.random() * 5) + 1;
				state.mp += plusMp;
				state.message.text = [
					MESSAGE_LEVEL_UP(nextLevel),
					MESSAGE_HP_INCREASED(plusHp),
					MESSAGE_MP_INCREASED(plusMp),
				].join('\n');
				state.message.visible = true;
			}
		},
	},
});
